import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from 'react-redux';

import Header from '../containers/header';
import Login from "./login";
import Cours from '../containers/cours';
import Produit from '../containers/produit';
import Of from '../containers/of';
import OfEdit from '../containers/ofEdit';
import requireAuth from '../helpers/require-authentification';
import tracerOf from '../containers/tracerOf';
import Livraison from '../containers/livraison';
import ofTools from './ofTools';
import Atelier from '../containers/Atelier';
import AnalyseJoaillier from '../containers/atelier/AnalyseJoaillier';
import ReceptionPierre from '../containers/pierre/ReceptionPierre';
import SortiePierre from '../containers/pierre/SortiePierre';
import StockPierre from './StockPierre';
import StockProduit from './StockProduit';
import CentreVide from './produit/CentreVide';
import Centre from './produit/Centre';
import SuppressionCvPierre from '../helpers/SuppressionCvPierre';
import ListePierre from '../containers/pierre/ListePierre';
import Avoir from '../containers/Avoir';
import ImageLoader from './ImageLoader';
import Images from './Images';
import RetourPierre from './pierre/RetourPierre';
import Client from '../containers/forms/Client';
import AffectationImage from './image/AffectationImage';
import AnalyseCa from '../containers/analyse/AnalyseCa';
import SuiviConnection from '../containers/analyse/SuiviConnection';
import ComparaisonCa from '../containers/analyse/ComparaisonCa';
import AnalyseFournisseur from '../containers/analyse/AnalyseFournisseur';
import Traite from './Traite';
import AnalyseStock from '../containers/analyse/AnalyseStock';
import Compta from '../containers/compta/Compta';
import PlanningHebdomadaire from './planning/Planning';
import Besoin from '../containers/besoin/Besoin';
import ValorisationStock from '../containers/compta/ValorisationStock';
import ComptePoidsClients from '../containers/compta/ComptePoidsClients';
import AnalyseFacon from '../containers/analyse/AnalyseFacon';
import AnalyseAtelier from '../containers/atelier/analyse/AnalyseAtelier';
import EnvoiJoaillier from '../containers/atelier/envoi/EnvoiJoaillier';
import EnvoiSerti from '../containers/atelier/envoi/EnvoiSerti';
import FinaliserOf from '../containers/atelier/finaliser/FinaliserOf';
import EnvoiBoiteOr from '../containers/atelier/envoi/EnvoiBoiteOr';
import ReservationCollection from './produit/reservation/ReservationCollection';
import SvgGenerator from './svg/SvgGenerator';
import UpdateWordpress from './wordpress/UpdateWordpress';
import OfParStatut from './of/OfParStatut';
import SuiviCommande from '../containers/SuiviCommande';
import VariationCaClient from '../containers/analyse/VariationCaClient';
import AnalysePrix from '../containers/analyse/AnalysePrix';
import AnalyseMarges from '../containers/AnalyseMarges';
import Devis from './devis/Devis';
import AnalyseMetal from '../containers/atelier/AnalyseMetal';
import SuiviProduction from '../containers/analyse/SuiviProduction';
import GoldFormContainer from '../containers/forms/GoldFormContainer';
import MouvementsOrList from '../containers/forms/MouvementsOrList';
import PeseePage from '../containers/atelier/PeseePage';
import DoublonPierre from './administration/DoublonPierre';
import ClientManager from './clients/ClientManager';
import ImportClient from './clients/ImportClient';
import AnalyseConso from '../containers/pierre/AnalyseConso';
import ReleveHeures from '../containers/commercial/ReleveHeures';

import "../style.css";

let cachedUserStr = null;
let cachedUserObj = null;

const getStoredUser = () => {
  const stored = localStorage.getItem('user');
  if (!stored) {
    cachedUserStr = null;
    cachedUserObj = null;
    return null;
  }
  if (stored === cachedUserStr) return cachedUserObj;
  try {
    cachedUserStr = stored;
    cachedUserObj = JSON.parse(stored)?.[0] || null;
    return cachedUserObj;
  } catch {
    return null;
  }
};

class App extends Component {
  // Fonction de verrouillage centralisée
  redirectSiNecessaire() {
    const { isLoggedIn, user, location, history } = this.props;
    if (!isLoggedIn || !user) return;

    const idUser = Number(user.id ?? user.id_user);
    const isCommercial = [150, 216].includes(idUser);
    const isAtelier = user.role === 5;
    const isAdmin = user.role === 1 || user.role === 6;

    // L'Admin va où il veut sans être redirigé
    if (isAdmin) return;

    // Enlève le slash final (ex: /commercial/ devient /commercial) pour éviter les faux-positifs
    const currentPath = location.pathname.replace(/\/$/, "");

    // Bloque le Commercial hors de /commercial
    if (isCommercial) {
      if (currentPath !== "/commercial") {
        history.replace("/commercial");
      }
    }
    // Bloque l'Atelier hors des zones Atelier
    else if (isAtelier) {
      if (!currentPath.startsWith("/atelier") && currentPath !== "/finaliser" && currentPath !== "/mouvements_or" && currentPath !== "/serti/envoi") {
        history.replace("/atelier");
      }
    }
  }

  componentDidMount() {
    this.redirectSiNecessaire();
  }

  // --- CORRECTION ANTI BOUCLE INFINIE ---
  // On ne déclenche la vérification que si le chemin (pathname) vient de changer,
  // ou si la connexion vient de changer (évite que React le lance en boucle à chaque re-rendu)
  componentDidUpdate(prevProps) {
    if (
      this.props.location.pathname !== prevProps.location.pathname ||
      this.props.isLoggedIn !== prevProps.isLoggedIn
    ) {
      this.redirectSiNecessaire();
    }
  }

  render() {
    const { isLoggedIn, user } = this.props;

    const idUser = Number(user?.id ?? user?.id_user);
    const isCommercial = [150, 216].includes(idUser);
    const isAtelier = user?.role === 5;

    return (
      <div>
        {isLoggedIn && <Header />}
        <div className="container-fluid body_content">
          <Switch>
            {/* Redirection Initiale intelligente au Login */}
            <Route
              exact
              path="/"
              render={(routeProps) => {
                if (!isLoggedIn) return <Login {...routeProps} />;
                if (isCommercial) return <Redirect to="/commercial" />;
                if (isAtelier) return <Redirect to="/atelier" />;
                return <Redirect to="/produit" />;
              }}
            />

            {/* --- ROUTES PROTEGÉES --- */}
            {/* Si requireAuth fait crasher, on peut le bypasser juste pour voir */}
            <Route exact path="/commercial" component={requireAuth(ReleveHeures)} />

            {/* Administration & Général */}
            <Route exact path="/cours" component={requireAuth(Cours)} />
            <Route exact path="/svg" component={requireAuth(SvgGenerator)} />
            <Route exact path="/wp" component={requireAuth(UpdateWordpress)} />
            <Route exact path="/administration/doublon-pierre" component={requireAuth(DoublonPierre)} />
            <Route exact path="/administration/clients" component={requireAuth(ClientManager)} />
            <Route exact path="/import-client" component={requireAuth(ImportClient)} />
            <Route exact path="/client" component={requireAuth(Client)} />

            {/* Produits */}
            <Route exact path="/produit" component={requireAuth(Produit)} />
            <Route exact path="/produit/stock" component={requireAuth(StockProduit)} />
            <Route exact path="/produit/cv" component={requireAuth(CentreVide)} />
            <Route exact path="/produit/centre" component={requireAuth(Centre)} />
            <Route exact path="/reservation" component={requireAuth(ReservationCollection)} />
            <Route exact path="/devis" component={requireAuth(Devis)} />

            {/* Ordres de Fabrication (OF) */}
            <Route exact path="/of" component={requireAuth(Of)} />
            <Route exact path="/planning" component={requireAuth(PlanningHebdomadaire)} />
            <Route exact path="/of/edit" component={requireAuth(OfEdit)} />
            <Route exact path="/of/tracer" component={requireAuth(tracerOf)} />
            <Route exact path="/of/tools" component={requireAuth(ofTools)} />
            <Route exact path="/of/besoin" component={requireAuth(Besoin)} />

            {/* Facturation & Compta */}
            <Route exact path="/livraison" component={requireAuth(Livraison)} />
            <Route exact path="/compta" component={requireAuth(Compta)} />
            <Route exact path="/compta/compte_poids" component={requireAuth(ComptePoidsClients)} />
            <Route exact path="/valorisation" component={requireAuth(ValorisationStock)} />
            <Route exact path="/traite" component={requireAuth(Traite)} />
            <Route exact path="/avoir" component={requireAuth(Avoir)} />

            {/* Suivi & Analyses */}
            <Route exact path="/filter" component={requireAuth(SuiviCommande)} />
            <Route exact path="/suivi_prod" component={requireAuth(OfParStatut)} />
            <Route exact path="/suivi_production" component={requireAuth(SuiviProduction)} />
            <Route exact path="/suivi_connection" component={requireAuth(SuiviConnection)} />
            <Route exact path="/analyse_ca" component={requireAuth(AnalyseCa)} />
            <Route exact path="/variation_ca_client" component={requireAuth(VariationCaClient)} />
            <Route exact path="/analyse_prix" component={requireAuth(AnalysePrix)} />
            <Route exact path="/analyse_marges" component={requireAuth(AnalyseMarges)} />
            <Route exact path="/analyse_metal" component={requireAuth(AnalyseMetal)} />
            <Route exact path="/analyse_fournisseur" component={requireAuth(AnalyseFournisseur)} />
            <Route exact path="/comparaison_ca" component={requireAuth(ComparaisonCa)} />
            <Route exact path="/analyse_stock" component={requireAuth(AnalyseStock)} />
            <Route exact path="/facon" component={requireAuth(AnalyseFacon)} />

            {/* Atelier */}
            <Route exact path="/atelier" component={requireAuth(Atelier)} />
            <Route exact path="/atelier/analyse" component={requireAuth(AnalyseJoaillier)} />
            <Route exact path="/atelier/analyse_ouvrier" component={requireAuth(AnalyseAtelier)} />
            <Route exact path="/atelier/envoi" component={requireAuth(EnvoiJoaillier)} />
            <Route exact path="/serti/envoi" component={requireAuth(EnvoiSerti)} />
            <Route exact path="/finaliser" component={requireAuth(FinaliserOf)} />
            <Route exact path="/atelier/boite_or" component={requireAuth(EnvoiBoiteOr)} />
            <Route exact path="/gold-form" component={requireAuth(GoldFormContainer)} />
            <Route exact path="/mouvements_or" component={requireAuth(MouvementsOrList)} />
            <Route exact path="/atelier/pesee" component={requireAuth(PeseePage)} />

            {/* Pierres */}
            <Route exact path="/pierre" component={requireAuth(ListePierre)} />
            <Route exact path="/pierre/reception" component={requireAuth(ReceptionPierre)} />
            <Route exact path="/pierre/sortie" component={requireAuth(SortiePierre)} />
            <Route exact path="/pierre/stock" component={requireAuth(StockPierre)} />
            <Route exact path="/pierre/retour" component={requireAuth(RetourPierre)} />
            <Route exact path="/pierre/analyse_conso" component={requireAuth(AnalyseConso)} />

            {/* Images & Tests */}
            <Route exact path="/upload" component={requireAuth(ImageLoader)} />
            <Route exact path="/image" component={requireAuth(Images)} />
            <Route exact path="/affectation" component={requireAuth(AffectationImage)} />
            <Route exact path="/test" component={requireAuth(SuppressionCvPierre)} />

            {/* Fallback en cas d'URL inconnue */}
            <Redirect to="/" />
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoggedIn: state.authentification.isLoggedIn,
  user: state.authentification.user || getStoredUser()
});

export default withRouter(connect(mapStateToProps)(App));